// 本地练习数据持久化（localStorage）
// 数据结构：
// {
//   sessions: [
//     {
//       date: "2024-01-15",          // 做题日期 YYYY-MM-DD
//       totalAnswered: 10,           // 做了多少题
//       knowledgePoints: [...],      // 涉及的知识点列表
//       errors: [                    // 错误详情
//         { questionId, number, knowledgePoint, userAnswer, correctAnswer }
//       ],
//       abilityRating: "B1"          // 当前能力评级
//     }
//   ]
// }

const STORAGE_KEY = "bjt_practice_data";

function loadData() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { sessions: [] };
  } catch {
    return { sessions: [] };
  }
}

function saveData(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

// 根据正确率计算能力评级
function calcAbilityRating(correct, total) {
  if (total === 0) return "未评级";
  const rate = correct / total;
  if (rate >= 0.9) return "A";
  if (rate >= 0.75) return "B+";
  if (rate >= 0.6) return "B";
  if (rate >= 0.45) return "C+";
  if (rate >= 0.3) return "C";
  return "D";
}

// 保存一次练习会话
// answers: { [questionId]: userAnswerIndex }
// questionList: 当前题目列表
export function saveSession(questionList, answers) {
  const data = loadData();

  const errors = [];
  const knowledgePointsSet = new Set();
  let correctCount = 0;
  let answeredCount = 0;

  questionList.forEach((q) => {
    const userAnswer = answers[q.id];
    if (userAnswer === undefined) return;
    answeredCount++;
    if (q.knowledgePoint) knowledgePointsSet.add(q.knowledgePoint);
    if (userAnswer === q.answer) {
      correctCount++;
    } else {
      errors.push({
        questionId: q.id,
        number: q.number,
        knowledgePoint: q.knowledgePoint || "",
        userAnswer,
        correctAnswer: q.answer,
      });
    }
  });

  const session = {
    date: new Date().toISOString().split("T")[0],
    totalAnswered: answeredCount,
    knowledgePoints: Array.from(knowledgePointsSet),
    errors,
    abilityRating: calcAbilityRating(correctCount, answeredCount),
  };

  data.sessions.push(session);
  saveData(data);
  return session;
}

// 读取所有历史会话
export function getAllSessions() {
  return loadData().sessions;
}

// 读取全局累计统计
export function getGlobalStats() {
  const { sessions } = loadData();
  let totalAnswered = 0;
  let totalErrors = 0;
  sessions.forEach((s) => {
    totalAnswered += s.totalAnswered;
    totalErrors += s.errors.length;
  });
  const correct = totalAnswered - totalErrors;
  const rate = totalAnswered > 0 ? ((correct / totalAnswered) * 100).toFixed(2) : "0.00";
  return { totalAnswered, correct, totalErrors, rate };
}

// 清空所有数据
export function clearAllData() {
  saveData({ sessions: [] });
}
